import { render } from "./SampleInformation.vue?vue&type=template&id=502b5e73"
import script from "./SampleInformation.vue?vue&type=script&lang=js"
export * from "./SampleInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__